//index.js
import './polyfills'; // Importer les polyfills en premier
// i18n AVANT TOUT LE RESTE (les polyfills exceptes).
//
// Deux raisons, et l'ordre compte pour les deux :
//   - des registres evaluent `i18n.t()` au niveau du MODULE, donc a leur
//     import. Tout ce qui est importe avant l'initialisation rendrait des
//     cles brutes, une fois, sans erreur ;
//   - la langue resolue est posee sur <html lang/dir> des ce moment, sinon
//     la premiere peinture se fait de gauche a droite et une interface arabe
//     sauterait sous les yeux de l'usager.
import { pretI18n } from './i18n';
import ReactDOM from 'react-dom/client';
import './styles/global.css'; // Design system (tokens + composants)
import './index.css';
import './consoleWrapper';
import { installGlobalErrorReporting } from './utils/reportClientError';
import ErrorBoundary from './composants/ErrorBoundary';
import { initialiserInstallationApp } from './utils/installationApp';
import { planifierEnregistrementServiceWorker } from './utils/enregistrerServiceWorker';

// `AppRouter` N'EST PAS IMPORTE ICI, ET C'EST VOULU — voir le bas du fichier.

// Remontée des erreurs qui échappent à l'ErrorBoundary : promesses rejetées sans
// `.catch()`, erreurs dans un setTimeout ou un gestionnaire d'événement. Elles ne
// cassent pas le rendu, donc React ne les voit pas — mais ce sont de vrais
// défauts, et ils ne laissaient jusqu'ici aucune trace exploitable.
installGlobalErrorReporting();

// Application installable. L'ordre compte : `beforeinstallprompt` doit être
// intercepté avant que le navigateur ne l'émette, donc avant le rendu de React.
// L'enregistrement du service worker, lui, attend la fin du chargement pour ne
// pas disputer la bande passante au premier écran.
initialiserInstallationApp();
planifierEnregistrementServiceWorker();

const container = document.getElementById('app');

// ON ATTEND LE CATALOGUE DE LA LANGUE RESOLUE avant de peindre.
//
// i18next demarre avec le seul francais ; les autres langues se chargent a la
// demande, pour ne pas faire payer a chacun celles qu'il n'ouvrira pas. Monter
// React avant que ce chargement finisse donnait un ecran ENTIEREMENT francais
// sous un `lang="en"` : la bascule semblait ne rien faire.
//
// La promesse est deja resolue quand la langue est le francais : le cas
// courant n'attend rien. Et si le chargement echoue, on monte quand meme —
// une interface en francais vaut mieux qu'une page blanche.
// L'ARBRE N'EST IMPORTE QU'APRES : un import statique s'evalue AVANT.
//
// Attendre `pretI18n` pour PEINDRE ne suffisait pas. Les imports d'un module
// ES sont hisses et evalues au chargement, bien avant que la promesse se
// resolve — or plusieurs registres appellent `i18n.t()` AU NIVEAU DU MODULE :
// `builderSections.js` (d'ou viennent aussi `FAMILLES` et `ASSISTANT_TYPES`),
// `moduleRegistry.js`, `onboardingTours.js`. Ces appels rendaient donc le
// FRANCAIS, une seule fois, definitivement : sur la page d'accueil arabe,
// « Parcours guidé » restait en francais a cote d'un titre arabe, et le plan
// du constructeur affichait « Présentation », « Identité », « Scénario ».
//
// Un `import()` dynamique deplace l'evaluation de tout le graphe apres le
// chargement du catalogue. Le cout est d'un aller-retour supplementaire au
// premier ecran ; le bundler emet un `modulepreload` qui l'absorbe en grande
// partie. L'alternative — un accesseur paresseux sur chaque libelle de chaque
// registre — se serait oubliee au premier registre ajoute.
//
// LE CHARGEMENT DE `AppRouter` EST LE SEUL ENDROIT QU'AUCUN ErrorBoundary NE COUVRE :
// l'arbre n'existe pas encore. Un onglet resté ouvert (ou restauré par Safari) à
// travers un déploiement redemande `AppRouter-<ancien hash>.js`, que le
// `rsync --delete` a supprimé : l'`import()` rejetait, personne ne rechargeait, et
// l'usager restait devant une page BLANCHE. Vu sur la route `/` (« Importing a
// module script failed », 1 à 7 fois par jour depuis septembre 2026). On rend donc
// l'échec DANS un ErrorBoundary, qui sait déjà recharger une fois (chunk obsolète),
// puis afficher un écran lisible si le rechargement n'y change rien.
const EchecDeDemarrage = ({ erreur }) => {
    throw erreur;
};

const monter = async () => {
    const racine = ReactDOM.createRoot(container);
    try {
        const { default: AppRouter } = await import('./AppRouter');
        racine.render(<AppRouter />);
    } catch (erreur) {
        racine.render(
            <ErrorBoundary>
                <EchecDeDemarrage erreur={erreur} />
            </ErrorBoundary>
        );
    }
};

// Si le chargement du catalogue echoue, on monte quand meme : une interface en
// francais vaut mieux qu'une page blanche.
pretI18n.then(monter, monter);